/* eslint-disable */

import FileSaver from "file-saver";

class FileLoader {
  type = "text/csv;charset=utf-8";
  constructor(bytes, fileName, isB64, type) {
    this.bytes = bytes;
    this.fileName = fileName;
    this.type = type;
    if (isB64) {
      this.blob = this.b64toBlob();
    } else {
      this.blob = new Blob([bytes], { type: type });
    }
  }
  download() {
    FileSaver.saveAs(this.blob, this.fileName);
  }
  b64toBlob(sliceSize = 512) {
    const byteCharacters = atob(this.bytes);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays);
    return blob;
  }
}

export default FileLoader;
